/* Copyright (c) 2024 Xperi. All Rights Reserved.  */

export const SET_LIST_ENTRY = 'SET_LIST_ENTRY';
export const REMOVE_LIST_ENTRY = 'REMOVE_LIST_ENTRY';
export const SET_LIST_ENTRY_LIMIT = 'SET_LIST_ENTRY_LIMIT';
export const SET_LIST_ENTRY_POSITION = 'SET_LIST_ENTRY_POSITION';
export const SET_LIST_ENTRY_FOCUS = 'SET_LIST_ENTRY_FOCUS';
